/**
 * LoadMore
 * ======================================
 * - load more posts via ajax
 */

 import Masonry from 'masonry-layout';

 const BTNS = ".js-LoadMoreButton";
 const TARGET = '.js-LoadMoreTarget'
 const ANIMATE_ELEMENTS = '.animate'
 const VISIBLE_CLASS = 'animate--visible'

 class LoadMore {
   constructor() {
     this.btns = document.querySelectorAll(BTNS);
     this.ajaxUrl = '/app/themes/ipress/ajax/index.php'

     if (!this.btns) {
       return false;
     }

     this.btns.forEach((el) => {
       el.addEventListener("click", this.clickHandler);
     });
   }

   clickHandler = (e) => {
     const el = e.currentTarget;
     const data = JSON.parse(el.getAttribute('data-ajax'))

     this.ajaxHandler(el, data)
   };

   ajaxHandler = (button, data) => {
    const parent = button.closest('.section')
    const target = parent.querySelector(TARGET)

    button.classList.add('is-loading')

    const xhr = new XMLHttpRequest()
    xhr.parent = this;
    xhr.open('POST', this.ajaxUrl, true)
    xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    xhr.send("action=loadMore&lang="+lang+"&template="+data.template+"&posttype="+data.posttype+"&term="+data.term+"&perpage="+data.perpage+"&page="+data.page+"&remaining="+data.remaining)

    xhr.onreadystatechange = function() {
      if (xhr.readyState === 4) {
        // ok
        if (xhr.status === 200) {
          const response = JSON.parse(xhr.response)

          if(data.posttype == 'review') {
            const parser = new DOMParser();
            const parserDocument = parser.parseFromString(response.html, 'text/html')
            const responseChildNodes = parserDocument.body.childNodes
            const masonryEL = document.querySelector('.js-ReviewsMasonry')
            const masonry = Masonry.data(masonryEL)

            responseChildNodes.forEach(item => {
              target.appendChild(item)
              masonry.appended( item )
            })
          } else {
            target.insertAdjacentHTML('beforeend', response.html)
            }

            target.querySelectorAll(ANIMATE_ELEMENTS).forEach((el) => {
              el.classList.add(VISIBLE_CLASS)
            })
          button.setAttribute('data-ajax', response.attrs)
          button.classList.remove('is-loading')

          if(response.more == false) {
            button.classList.add('is-no-more')
          }
        }
        // error
        else {
          console.log('ajaxForm error!', xhr)
        }
      }
    }
  }
 }

 new LoadMore();
